import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Loader from '@tcl-boron-prefabs/loader';
import cn from 'classnames';
import withStyles from '@tempus/component-library/utils/withStyles';
import styles from '../../styles';
import qs from 'query-string';
import { handleEhrCodeExchange, isValidEHRQueryParams } from '../../utils/ehr-launch-utils';
import typography from '@tcl-boron-styles/typography/dist/index.module.css';

function EhrCallBack({ classes }) {
  const history = useHistory();
  const [error, setError] = React.useState(false);

  useEffect(() => {
    async function getRedirectUrl() {
      const query = qs.parse(window.location.search);
      if (isValidEHRQueryParams(query)) {
        const redirect = await handleEhrCodeExchange(query.code);
        if (redirect) {
          history.push({
            pathname: '/',
            search: `?redirect=${encodeURIComponent(redirect)}&fromEHR=true`,
          });
        } else {
          setError(true);
        }
      }
    }
    getRedirectUrl();
  }, []); // eslint-disable-line

  if (error) {
    return (
      <div className={cn('app-view-container')}>
        <>
          <h1 className={cn(typography.H1)} data-testid="submitted-header">
            Error Launching Application
          </h1>
          <p className={cn(typography.Paragraph)} data-testid="submitted-paragraph">
            We're sorry, but we couldn't launch the EHR application.
          </p>
          <p className={cn(typography.Paragraph)} data-testid="submitted-paragraph">
            Contact{' '}
            <a className={cn(typography.link)} href="mailto:support@tempus.com">
              support@tempus.com{' '}
            </a>
            or call 800-739-4137 for assistance.
          </p>
        </>
      </div>
    );
  }

  return (
    <div className={cn('app-view-container', classes.loadingContainer)}>
      <Loader />
    </div>
  );
}

export default withStyles(styles)(EhrCallBack);
